<app-card-content [border]="false" [title]="'Usuários do Sistema'" [icon]="'pi pi-users'" [subtitle]="'Gerencie usuários e permissões de acesso ao portal'">
    <div card-header>
        <p-button label="Novo Usuário" icon="pi pi-plus" size="small" styleClass="whitespace-nowrap" [appCan]="roleUsuariosCriar" (onClick)="novoUsuario()" />
    </div>

    <!-- Estatísticas -->
    <div class="grid grid-cols-3 gap-3 mb-5">
        <div class="flex items-center gap-3 p-4 rounded-xl bg-surface-50 dark:bg-surface-800 border border-surface-200 dark:border-surface-700">
            <div class="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                <i class="pi pi-users text-primary"></i>
            </div>
            <div>
                <div class="text-2xl font-bold leading-none">{{ _usuarios().length }}</div>
                <div class="text-xs text-muted-color mt-0.5">Total de usuários</div>
            </div>
        </div>
        <div class="flex items-center gap-3 p-4 rounded-xl bg-surface-50 dark:bg-surface-800 border border-surface-200 dark:border-surface-700">
            <div class="w-10 h-10 rounded-full bg-green-500/10 flex items-center justify-center shrink-0">
                <i class="pi pi-check-circle text-green-500"></i>
            </div>
            <div>
                <div class="text-2xl font-bold leading-none text-green-600 dark:text-green-400">{{ totalAtivos() }}</div>
                <div class="text-xs text-muted-color mt-0.5">Ativos</div>
            </div>
        </div>
        <div class="flex items-center gap-3 p-4 rounded-xl bg-surface-50 dark:bg-surface-800 border border-surface-200 dark:border-surface-700">
            <div class="w-10 h-10 rounded-full bg-red-500/10 flex items-center justify-center shrink-0">
                <i class="pi pi-ban text-red-500"></i>
            </div>
            <div>
                <div class="text-2xl font-bold leading-none text-red-500 dark:text-red-400">{{ totalInativos() }}</div>
                <div class="text-xs text-muted-color mt-0.5">Inativos</div>
            </div>
        </div>
    </div>

    <!-- Filtros (padrão /configuracoes/gerais/servicos) -->
    <app-filtros-bar (limpar)="limparFiltros()" (filtrar)="aplicarFiltros()">
        <app-filtro-campo [label]="isUsuarioBR() ? 'Filtrar por UF' : 'UF'">
            <div class="flex items-center gap-2 h-full">
                <!-- Alternar entre "a minha UF" e "todas" só faz sentido para quem enxerga mais de uma. -->
                @if (isUsuarioBR()) {
                    <p-toggleswitch [ngModel]="filtrarPorUf()" (ngModelChange)="onFiltrarPorUfChange($event)" />
                }
                <app-estado-select class="flex-1 min-w-0" [uf]="ufFiltro()" [disabled]="ufTravada() || !filtrarPorUf()" (ufChange)="onEstadoChange($event)" />
            </div>
        </app-filtro-campo>
        <app-filtro-campo label="Nome, UF ou User ID" [wide]="true" inputId="usuarios-filtro-nome">
            <input id="usuarios-filtro-nome" pInputText type="text" class="w-full" [ngModel]="filtroNomeInput()" (ngModelChange)="filtroNomeInput.set($event)" (keyup.enter)="aplicarFiltros()" placeholder="Buscar usuário..." />
        </app-filtro-campo>
        <app-filtro-campo label="Status">
            <p-select
                [options]="opcoesStatus"
                [ngModel]="filtroStatusInput()"
                (ngModelChange)="filtroStatusInput.set($event)"
                optionLabel="label"
                optionValue="value"
                placeholder="Todos os status"
                [showClear]="true"
                appendTo="body"
                styleClass="w-full"
            />
        </app-filtro-campo>
        <app-filtro-campo label="Ordenação">
            <p-select [options]="sortOpcoes" [ngModel]="ordenacao()" (ngModelChange)="ordenacao.set($event)" optionLabel="label" placeholder="Ordenar por..." styleClass="w-full" appendTo="body" />
        </app-filtro-campo>
    </app-filtros-bar>

    <!-- Barra de status -->
    <div class="flex justify-between items-center gap-3 mb-4">
        <div class="flex items-center gap-2">
            <span class="text-sm text-surface-400 dark:text-surface-500">
                <span class="font-bold text-surface-700 dark:text-surface-200">{{ usuariosFiltrados().length }}</span>
                {{ usuariosFiltrados().length === 1 ? 'usuário' : 'usuários' }}
            </span>
            @if (isUsuarioBR() && filtrarPorUfAplicado() && ufFiltroAplicado()) {
                <span class="inline-flex items-center gap-1 bg-primary/10 dark:bg-primary/20 text-primary text-[10px] font-bold px-2.5 py-0.5 rounded-full tracking-wide">
                    <i class="pi pi-map-marker" style="font-size: 0.55rem"></i>
                    {{ ufFiltroAplicado() }}
                </span>
            } @else if (isUsuarioBR() && !filtrarPorUfAplicado()) {
                <span class="inline-flex items-center gap-1 bg-surface-100 dark:bg-surface-700 text-surface-500 dark:text-surface-400 text-[10px] font-bold px-2.5 py-0.5 rounded-full tracking-wide">
                    <i class="pi pi-globe" style="font-size: 0.55rem"></i>
                    Todas as UFs
                </span>
            }
        </div>
        <app-table-view-switcher [(viewMode)]="viewMode" />
    </div>

    <!-- Vista: Tabela -->
    @if (viewMode() === 'table') {
        <p-table
            [value]="usuariosFiltrados()"
            [loading]="carregando()"
            [paginator]="true"
            [rows]="cardPageSize()"
            [rowsPerPageOptions]="[15, 30, 50]"
            [stripedRows]="true"
            [rowHover]="true"
            styleClass="p-datatable-sm"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="{first}–{last} de {totalRecords}"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Usuário</th>
                    <th style="width: 60px" class="text-center">UF</th>
                    <th>User ID (Keycloak)</th>
                    <th class="text-center" style="width: 90px">Status</th>
                    <th class="text-center" style="width: 120px">Ações</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-usuario>
                <tr>
                    <td>
                        <div class="usuario-celula">
                            <app-pessoa-avatar [foto]="usuario.avatar" [iniciais]="iniciais(usuario)" [nome]="usuario.nmSolicitante || ''" tamanho="xxl" [clicavel]="true" (fotoSelecionada)="ampliarFoto($event, usuario)" />
                            <div class="flex flex-col gap-0.5 min-w-0">
                                <span class="font-medium text-sm">{{ usuario.nmSolicitante || '—' }}</span>
                                @if (usuario.cpf) {
                                    <span class="text-xs text-muted-color">{{ usuario.cpf }}</span>
                                }
                            </div>
                        </div>
                    </td>
                    <td class="text-center">
                        <span class="text-xs font-semibold text-muted-color">{{ usuario.ufSolicitante }}</span>
                    </td>
                    <td>
                        <span class="text-xs text-muted-color font-mono truncate block max-w-56" [title]="usuario.userId">{{ usuario.userId }}</span>
                    </td>
                    <td class="text-center">
                        <p-tag [severity]="statusSeverity(usuario.inAtivo)" [value]="usuario.inAtivo === 'S' ? 'Ativo' : 'Inativo'" />
                    </td>
                    <td>
                        <div class="flex justify-center gap-0.5">
                            <p-button icon="pi pi-pencil" ariaLabel="Editar" size="small" severity="secondary" [text]="true" [rounded]="true" [appCan]="roleUsuariosEditar" pTooltip="Editar" tooltipPosition="top" (onClick)="editarUsuario(usuario)" />
                            <p-button
                                icon="pi pi-shield"
                                ariaLabel="Permissões"
                                size="small"
                                severity="secondary"
                                [text]="true"
                                [rounded]="true"
                                [appCan]="rolePermAdmin"
                                [disabled]="!usuario.userId"
                                pTooltip="Permissões"
                                tooltipPosition="top"
                                (onClick)="gerenciarPermissoes(usuario)"
                            />
                            <p-button
                                [icon]="usuario.inAtivo === 'S' ? 'pi pi-ban' : 'pi pi-check-circle'"
                                size="small"
                                [severity]="usuario.inAtivo === 'S' ? 'warn' : 'success'"
                                [text]="true"
                                [rounded]="true"
                                [appCan]="roleUsuariosAlterarStatus"
                                [pTooltip]="usuario.inAtivo === 'S' ? 'Inativar' : 'Ativar'"
                                tooltipPosition="top"
                                (onClick)="confirmarToggleStatus(usuario)"
                            />
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="5" class="py-12">
                        <div class="flex flex-col items-center gap-3 text-muted-color">
                            <i class="pi pi-users text-5xl opacity-20"></i>
                            <span class="text-sm">Nenhum usuário encontrado.</span>
                            @if (filtroNome() || filtroStatus() || filtrarPorUfAplicado()) {
                                <p-button label="Limpar filtros" severity="secondary" [text]="true" size="small" (onClick)="limparFiltros()" />
                            }
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    }

    <!-- Vista: Cards -->
    @if (viewMode() === 'card') {
        @if (usuariosFiltrados().length === 0) {
            <div class="flex flex-col items-center gap-3 text-muted-color py-12">
                <i class="pi pi-users text-5xl opacity-20"></i>
                <span class="text-sm">Nenhum usuário encontrado.</span>
                @if (filtroNome() || filtroStatus() || filtrarPorUfAplicado()) {
                    <p-button label="Limpar filtros" severity="secondary" [text]="true" size="small" (onClick)="limparFiltros()" />
                }
            </div>
        }

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            @for (usuario of usuariosPaginados(); track usuario.id) {
                <app-card-container>
                    <div class="flex flex-col gap-3 p-1">
                        <!-- Avatar + Nome -->
                        <div class="flex items-center gap-3">
                            <app-pessoa-avatar [foto]="usuario.avatar" [iniciais]="iniciais(usuario)" [nome]="usuario.nmSolicitante || ''" tamanho="xxl" [clicavel]="true" (fotoSelecionada)="ampliarFoto($event, usuario)" />
                            <div class="flex flex-col gap-0.5 min-w-0">
                                <span class="font-semibold text-sm leading-tight truncate">
                                    {{ usuario.nmSolicitante || '—' }}
                                </span>
                                @if (usuario.cpf) {
                                    <span class="text-xs text-muted-color">{{ usuario.cpf }}</span>
                                }
                            </div>
                        </div>

                        <!-- Detalhes -->
                        <div class="grid grid-cols-2 gap-x-3 gap-y-1 text-xs">
                            <div class="text-muted-color">UF</div>
                            <div class="font-semibold">{{ usuario.ufSolicitante }}</div>
                            <div class="text-muted-color col-span-2 font-mono opacity-60 truncate" [title]="usuario.userId">{{ usuario.userId }}</div>
                        </div>

                        <!-- Status + Ações -->
                        <div class="flex items-center justify-between pt-1 border-t border-surface-200 dark:border-surface-700">
                            <p-tag [severity]="statusSeverity(usuario.inAtivo)" [value]="usuario.inAtivo === 'S' ? 'Ativo' : 'Inativo'" />
                            <div class="flex gap-0.5">
                                <p-button
                                    icon="pi pi-pencil"
                                    ariaLabel="Editar"
                                    size="small"
                                    severity="secondary"
                                    [text]="true"
                                    [rounded]="true"
                                    [appCan]="roleUsuariosEditar"
                                    pTooltip="Editar"
                                    tooltipPosition="top"
                                    (onClick)="editarUsuario(usuario)"
                                />
                                <p-button
                                    icon="pi pi-shield"
                                    ariaLabel="Permissões"
                                    size="small"
                                    severity="secondary"
                                    [text]="true"
                                    [rounded]="true"
                                    [appCan]="rolePermAdmin"
                                    [disabled]="!usuario.userId"
                                    pTooltip="Permissões"
                                    tooltipPosition="top"
                                    (onClick)="gerenciarPermissoes(usuario)"
                                />
                                <p-button
                                    [icon]="usuario.inAtivo === 'S' ? 'pi pi-ban' : 'pi pi-check-circle'"
                                    size="small"
                                    [severity]="usuario.inAtivo === 'S' ? 'warn' : 'success'"
                                    [text]="true"
                                    [rounded]="true"
                                    [appCan]="roleUsuariosAlterarStatus"
                                    [pTooltip]="usuario.inAtivo === 'S' ? 'Inativar' : 'Ativar'"
                                    tooltipPosition="top"
                                    (onClick)="confirmarToggleStatus(usuario)"
                                />
                            </div>
                        </div>
                    </div>
                </app-card-container>
            }
        </div>

        <!-- Paginação dos cards -->
        @if (usuariosFiltrados().length > 0) {
            <p-paginator
                [first]="cardPage() * cardPageSize()"
                [rows]="cardPageSize()"
                [totalRecords]="usuariosFiltrados().length"
                [rowsPerPageOptions]="[15, 30, 50]"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="{first}–{last} de {totalRecords}"
                (onPageChange)="onCardPageChange($event)"
                class="mt-4 border-t border-surface-200 dark:border-surface-700 pt-3"
            />
        }
    }
</app-card-content>

<p-confirmDialog />

<app-usuario-detalhe [(showDialog)]="modalDetalhe" [usuario]="usuarioSelecionado()" (salvo)="onUsuarioSalvo()" />

<p-dialog appDialogoPadrao="pi pi-shield" descricao="Perfis e roles atribuídos." header="Permissões do Usuário" [(visible)]="modalPermissoes" [style]="{ width: '900px' }">
    @if (userIdPermissoes(); as uid) {
        <app-atribuir-roles [userId]="uid" [nomeUsuario]="usuarioPermissoes()?.nmSolicitante ?? null" [ufUsuario]="usuarioPermissoes()?.ufSolicitante ?? null" [avatarUsuario]="usuarioPermissoes()?.avatar ?? null"></app-atribuir-roles>
    }
</p-dialog>

<app-pessoa-foto-dialog [(foto)]="fotoModalUrl" [nome]="nomeFotoAmpliada()" />
